import React from "react";
import { Input, Col, Row, Form } from "antd";

const { Item } = Form;

const MobileNumber = () => {
  return (
    <Row span={24}>
      <Col xs={24} md={12}>
        <Row xs={24} md={12}>
          <Col xs={8} md={8}>
            <h4>Mobile Number</h4>
          </Col>
          <Col xs={16} md={15}>
            <Item name="mobile">
              <Input
                size="large"
                name="mobile"
                style={{ borderRadius: 8 }}
                placeholder="Number"
              />
            </Item>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={12}>
        <Row justify="space-between">
          <Col xs={8} md={8}>
            <h4>Mobile Number 2</h4>
          </Col>
          <Col xs={16} md={15}>
            <Item name="mobile2">
              <Input
                size="large"
                name="mobile2"
                style={{ borderRadius: 8 }}
                placeholder="Number"
              />
            </Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default MobileNumber;
